import React from 'react';
import { Helmet } from 'react-helmet-async';
import { businessInfo } from '../config/business';

const SEO = ({ title, description, keywords, name, type }) => {
  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{title}</title>
      <meta name='description' content={description} />
      {keywords && <meta name='keywords' content={keywords} />}

      {/* Facebook tags */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content="https://www.kbakeryy.com/static/media/homecake.ea6c44363cca7d5b4c85.png" />
      
      {/* Twitter tags */}
      <meta name="twitter:creator" content={name} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content="https://www.kbakeryy.com/static/media/homecake.ea6c44363cca7d5b4c85.png" />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Bakery",
          "name": businessInfo.name,
          "image": "https://www.kbakeryy.com/static/media/homecake.ea6c44363cca7d5b4c85.png",
          "description": "Delicious cakes, brownies, cupcakes and more at K Bakery.",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": businessInfo.address.street,
            "addressLocality": businessInfo.address.city,
            "addressRegion": businessInfo.address.region,
            "postalCode": businessInfo.address.postalCode,
            "addressCountry": businessInfo.address.countryCode
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": businessInfo.coordinates.lat,
            "longitude": businessInfo.coordinates.lng
          },
          "telephone": "+14033603664",
          "priceRange": "$$",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday"
              ],
              "opens": "09:00",
              "closes": "23:00"
            }
          ],
          "url": "https://www.kbakeryy.com"
        })}
      </script>
    </Helmet>
  );
}

SEO.defaultProps = {
  title: 'K Bakery',
  description: 'Delicious cakes, brownies, cupcakes and more at K Bakery.',
  keywords: 'bakery, cakes, pastries, brownies, cupcakes, sweet',
  name: 'K Bakery',
  type: 'website'
};

export default SEO;
